import { render, staticRenderFns } from "./CampaignList.vue?vue&type=template&id=2c791e5a&"
import script from "./CampaignList.vue?vue&type=script&lang=js&"
export * from "./CampaignList.vue?vue&type=script&lang=js&"
import style0 from "./CampaignList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports